import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { TELL_TALE_SIZE, useTellTaleSize } from "@/hooks/userState/useTellTaleSize";

/** How wide each warning light is drawn; the lights fill the row and wrap at this size. */
export function TellTaleSizeSetting() {
  const { t } = useTranslation();
  const { px, setPx } = useTellTaleSize();

  return (
    <>
      <Typography variant="subtitle2" sx={{ mt: 2, mb: 1, maxWidth: 320 }}>
        {t("odometerSettings.tellTaleSize")}
      </Typography>
      <Box sx={{ px: 1, maxWidth: 320 }}>
        <Slider
          size="small"
          value={px}
          min={TELL_TALE_SIZE.min}
          max={TELL_TALE_SIZE.max}
          step={TELL_TALE_SIZE.step}
          marks={[
            { value: TELL_TALE_SIZE.min, label: TELL_TALE_SIZE.min },
            { value: TELL_TALE_SIZE.max, label: TELL_TALE_SIZE.max },
          ]}
          valueLabelDisplay="auto"
          onChange={(_event, next) => setPx(next as number)}
          aria-label={t("odometerSettings.tellTaleSize")}
        />
      </Box>
    </>
  );
}
